export default "__VITE_ASSET__Cvca$LBp__"